import { LogService } from "../../../../shared/services/log.service";
import { Validator } from "../../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../../ctrl.name.extractor";

export class CTRL_380 implements Validator {

    public static id = 'CTRL_380';
    private message = 'error.ctr_380';


    public LOG: LogService = new LogService(CTRL_380);

    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_380.id + '_');

        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const servicesNameWithStepId = map.get(ctrl.value.rgCtrls.services);
                const classPrincipaleNameWithStepId = map.get(ctrl.value.rgCtrls.classPrincipale);
                const servicesCtrl = form.controls[servicesNameWithStepId];
                const classPrincipaleCtrl = form.controls[classPrincipaleNameWithStepId];

                if ((servicesCtrl.value === 'travaux' && (classPrincipaleCtrl.value || '').substring(0,2) === '45') ||
                (servicesCtrl.value === 'fournitures' && ((classPrincipaleCtrl.value || '').substring(0,2) <= '44' || (classPrincipaleCtrl.value || '').substring(0,2) === '48')) ||
                (servicesCtrl.value === 'services' && (classPrincipaleCtrl.value || '').substring(0,2) >= '49' && (classPrincipaleCtrl.value || '').substring(0,2) <= '98')) {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
            }
        }
    }
}